import React from "react";
import {
  FiCheck,
  FiGrid,
  FiMessageSquare,
  FiMail,
  FiPhoneCall,
  FiBarChart2,
  FiLayers,
} from "react-icons/fi";
import { FaWhatsapp } from "react-icons/fa";
import styles from "./Onboarding.module.css";

const SERVICE_MAP = {
  sms:      { label: "SMS",      icon: FiMessageSquare },
  email:    { label: "Email",    icon: FiMail },
  voice:    { label: "Voice",    icon: FiPhoneCall },
  whatsapp: { label: "WhatsApp", icon: FaWhatsapp },
  rcs:      { label: "RCS",      icon: FiMessageSquare },
  flow:     { label: "Flow",     icon: FiGrid },
  campaign: { label: "Campaign", icon: FiLayers },
  analytics:{ label: "Analytics",icon: FiBarChart2 },
};

const StepComplete = ({ services = [], onDashboard }) => {
  if (!services.length) return null;

  return (
    <div className={styles.center}>
      <div className={styles.checkCircle}>
        <FiCheck size={22} />
      </div>

      <h1 className={styles.heading}>You're all set!</h1>

      <p className={styles.subheading}>
        Here's what you've selected. Everything is ready in your dashboard.
      </p>

      <div className={styles.selectedServicesGrid}>
        {services.map((key) => {
          const svc = SERVICE_MAP[key];
          if (!svc) return null;
          const Icon = svc.icon;
          return (
            <div key={key} className={styles.selectedServiceChip}>
              <Icon size={14} />
              <span>{svc.label}</span>
            </div>
          );
        })}
      </div>

      <button className={styles.primaryBtn} onClick={onDashboard}>
        Go to Dashboard
      </button>

    </div>
  );
};

export default StepComplete;
